import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon, Security as SecurityIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Enable2FAModal = ({ 
  open, 
  onClose 
}) => {
  const navigate = useNavigate();

  const handleGoToSettings = () => {
    navigate('/vendor/settings?tab=two_factor');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <SecurityIcon color="primary" />
            <Typography variant="h6" component="div">
              Enable Two-Factor Authentication
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Two-Factor Authentication is required to access files from other users.
          </Typography>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Please enable 2FA in your settings to access these files securely.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You will be redirected to the Two-Factor Authentication settings page.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={onClose} 
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          onClick={handleGoToSettings}
          variant="contained"
          startIcon={<SecurityIcon />}
        >
          Go to Settings
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Enable2FAModal;
